import { render } from "./FormItemSelector.vue?vue&type=template&id=683548ba"
import script from "./FormItemSelector.vue?vue&type=script&lang=js"
export * from "./FormItemSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__